/* Lookbook color filter - sections/cl-lookbook.liquid.
   Loaded without defer right after the grid, so a ?color=<palette> link is applied before the
   first paint. Every look is server-rendered; the filter only toggles `hidden`.

   Switching color uses the View Transitions API where the browser has it: each look carries
   its own view-transition-name, so looks that stay glide to their new place while the others
   fade. Without it, the grid crossfades; with reduced motion it swaps instantly. */
(function () {
  var params = new URLSearchParams(window.location.search);

  function init(root) {
    if (!root || root.clLbBound) return;
    root.clLbBound = true;

    var bar = root.querySelector('[data-lb-bar]');
    var track = root.querySelector('[data-lb-track]');
    var ink = root.querySelector('.cl-lb__ink');
    var grid = root.querySelector('[data-lb-grid]');
    var count = root.querySelector('[data-lb-count]');
    var chips = [].slice.call(root.querySelectorAll('[data-lb-filter]'));
    var items = [].slice.call(grid.querySelectorAll('.cl-lb__item'));
    var mores = [].slice.call(root.querySelectorAll('[data-lb-more]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 'all';
    var busy = false;

    function chipFor(f) {
      for (var i = 0; i < chips.length; i++) if (chips[i].getAttribute('data-lb-filter') === f) return chips[i];
      return null;
    }

    function moveInk(chip, instant) {
      if (!ink || !chip) return;
      var label = chip.querySelector('.cl-lb__label') || chip;
      ink.classList.toggle('no-anim', !!instant);
      ink.style.width = label.offsetWidth + 'px';
      // The chip is not positioned, so the label's offsets are already relative to the track.
      ink.style.top = (label.offsetTop + label.offsetHeight + 6) + 'px';
      ink.style.transform = 'translateX(' + label.offsetLeft + 'px)';
      ink.classList.add('is-ready');
      if (instant) { void ink.offsetWidth; ink.classList.remove('no-anim'); }
    }

    // Keep the chosen chip in view on a phone, where the row scrolls sideways.
    function centerChip(chip, instant) {
      if (!chip || track.scrollWidth <= track.clientWidth) return;
      var left = chip.offsetLeft - (track.clientWidth - chip.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: instant || reduce.matches ? 'auto' : 'smooth' });
    }

    function apply(f) {
      var visible = [];
      items.forEach(function (it) {
        var on = f === 'all' || (' ' + it.getAttribute('data-palettes') + ' ').indexOf(' ' + f + ' ') > -1;
        it.hidden = !on;
        if (on) visible.push(it);
      });
      mores.forEach(function (m) { m.hidden = m.getAttribute('data-lb-more') !== f; });
      if (count) {
        var n = visible.length;
        count.textContent = (n === 1 ? count.getAttribute('data-one') : count.getAttribute('data-many')).replace('[n]', n);
      }
      chips.forEach(function (c) {
        var on = c.getAttribute('data-lb-filter') === f;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      current = f;
    }

    function stickTop() {
      return parseFloat(getComputedStyle(bar).top) || 0;
    }

    // After a change, bring the start of the results back into view if the visitor had
    // scrolled past it - otherwise a short color could leave them looking at empty page.
    function scrollToResults() {
      var meta = root.querySelector('.cl-lb__meta');
      var target = grid.getBoundingClientRect().top - stickTop() - bar.offsetHeight - (meta ? meta.offsetHeight : 0) - 22;
      if (target < 0) window.scrollTo(0, window.pageYOffset + target);
    }

    function select(f, opts) {
      opts = opts || {};
      if (!chipFor(f) || busy) return;
      if (f === current && !opts.force) return;
      var chip = chipFor(f);
      moveInk(chip, opts.instant);
      centerChip(chip, opts.instant);

      if (!opts.instant) {
        try {
          var url = new URL(window.location.href);
          if (f === 'all') url.searchParams.delete('color'); else url.searchParams.set('color', f);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('cl_lookbook_filter', { color: f, looks: items.filter(function (it) { return f === 'all' || (' ' + it.getAttribute('data-palettes') + ' ').indexOf(' ' + f + ' ') > -1; }).length });
          }
        } catch (e) {}
      }

      if (opts.instant || reduce.matches) {
        apply(f);
        if (!opts.instant) scrollToResults();
        return;
      }

      if (document.startViewTransition) {
        busy = true;
        document.documentElement.classList.add('cl-lb-vt');
        var vt = document.startViewTransition(function () { apply(f); scrollToResults(); });
        vt.finished.then(done, done);
        return;
      }

      busy = true;
      grid.classList.add('is-fading');
      setTimeout(function () {
        apply(f);
        scrollToResults();
        requestAnimationFrame(function () { grid.classList.remove('is-fading'); busy = false; });
      }, 280);

      function done() {
        document.documentElement.classList.remove('cl-lb-vt');
        busy = false;
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () { select(c.getAttribute('data-lb-filter')); });
    });

    // Density: "less" (2 per row desktop / 1 mobile) or "more" (3 / 2). The visitor's choice is
    // kept in localStorage - a per-browser convenience, so failures are simply ignored.
    var densBtns = [].slice.call(root.querySelectorAll('[data-lb-density]'));
    var DKEY = 'clLookbookDensity';
    function applyDensity(d) {
      root.classList.toggle('cl-lb--more', d === 'more');
      densBtns.forEach(function (b) {
        var on = b.getAttribute('data-lb-density') === d;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function setDensity(d) {
      var isMore = root.classList.contains('cl-lb--more');
      if ((d === 'more') === isMore || busy) return;
      try { window.localStorage.setItem(DKEY, d); } catch (e) {}
      if (reduce.matches) { applyDensity(d); return; }
      if (document.startViewTransition) {
        busy = true;
        document.documentElement.classList.add('cl-lb-vt');
        var vt = document.startViewTransition(function () { applyDensity(d); });
        var end = function () { document.documentElement.classList.remove('cl-lb-vt'); busy = false; };
        vt.finished.then(end, end);
        return;
      }
      busy = true;
      grid.classList.add('is-fading');
      setTimeout(function () {
        applyDensity(d);
        requestAnimationFrame(function () { grid.classList.remove('is-fading'); busy = false; });
      }, 280);
    }
    densBtns.forEach(function (b) {
      b.addEventListener('click', function () { setDensity(b.getAttribute('data-lb-density')); });
    });
    var savedDensity = null;
    try { savedDensity = window.localStorage.getItem(DKEY); } catch (e) {}
    if (savedDensity === 'more' || savedDensity === 'less') applyDensity(savedDensity);

    // Sticky offset: the header's real bottom edge, so the bar tucks under the theme's sticky
    // header (and the announcement bar, when shown) at whatever height they have.
    var header = document.querySelector('theme-header') || document.querySelector('.header');
    var ticking = false;
    var lastTop = -1;
    function syncBar() {
      ticking = false;
      var top = 0;
      if (header) {
        var r = header.getBoundingClientRect();
        var pos = getComputedStyle(header).position;
        var sectionPos = header.closest('.header-section') ? getComputedStyle(header.closest('.header-section')).position : '';
        if (pos === 'fixed' || pos === 'sticky' || sectionPos === 'sticky' || sectionPos === 'fixed') top = Math.max(0, Math.round(r.bottom));
      }
      if (top !== lastTop) {
        root.style.setProperty('--cl-lb-top', top + 'px');
        lastTop = top;
      }
      var stuck = window.pageYOffset > 0 && bar.getBoundingClientRect().top <= top + 0.5;
      bar.classList.toggle('is-stuck', stuck);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(syncBar); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { onScroll(); moveInk(chipFor(current), true); });
    syncBar();

    var initial = params.get('color');
    if (initial && chipFor(initial)) select(initial, { instant: true, force: true });
    else { apply('all'); moveInk(chipFor('all'), true); }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveInk(chipFor(current), true); });
    window.addEventListener('load', function () { moveInk(chipFor(current), true); syncBar(); });
  }

  [].forEach.call(document.querySelectorAll('[data-cl-lb]'), init);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-cl-lb]'));
  });
})();
